/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-06-11T17:16:49.211
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listRentLegalEntity,
	listRentLegalEntityInit,
	listRentLegalEntityByAuthorizations,
	deleteRentLegalEntity,
    authenticationLegalentity
	
} from '@api/rentmanage/RentLegalEntity';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listRentLegalEntity({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentLegalEntity(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentLegalEntityByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentLegalEntityByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentLegalEntityInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentLegalEntityInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentLegalEntity({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentLegalEntity({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

        authenticationLegalentity({
        	state
        }, data) {
        	return new Promise((resolve, reject) => {
        		authenticationLegalentity(data)
        			.then(async res => {
        				resolve(res);
        			})
        			.catch(err => {
        				reject(err);
        			})
        	})
        },
	}
};
